import React, { useReducer } from 'react';

import { type Dispatch, retryActionReducer, type State } from './reducer';
import type { RetryActionStore } from './types';

const RetryActionContext = React.createContext<
  { state: State; dispatch: Dispatch } | undefined
>(undefined);

const defaultInitialState: State = {};

export const RetryActionProvider = ({
  value = defaultInitialState,
  children,
}: {
  value?: RetryActionStore;
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(retryActionReducer, value);

  return (
    <RetryActionContext.Provider value={{ state, dispatch }}>
      {children}
    </RetryActionContext.Provider>
  );
};

export const useRetryActionStore = () => {
  const context = React.useContext(RetryActionContext);

  if (context === undefined) {
    throw new Error(
      'useRetryActionStore must be used within an RetryActionProvider',
    );
  }

  return context;
};
